import { render, staticRenderFns } from "./TipoTalhaoManage.vue?vue&type=template&id=a3948d02&scoped=true"
import script from "./TipoTalhaoManage.vue?vue&type=script&lang=js"
export * from "./TipoTalhaoManage.vue?vue&type=script&lang=js"
import style0 from "./TipoTalhaoManage.vue?vue&type=style&index=0&id=a3948d02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3948d02",
  null
  
)

export default component.exports